import { useEffect } from "react";
import ModalWrapper from "../../../../components/Modal/ModalWrapper";
import CustomButton from "../../../../components/CustomButton";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { getClientsByPctLucru } from "../../../../redux/api/expedition.api";
import { clearWorkingPointClients } from "../../../../redux/reducer/expedition.reducer";

function WorkingPointClientsModal({
  workingPointId,
  workingPointName,
  onClose,
}: {
  workingPointId: number | string;
  workingPointName?: string;
  onClose: () => void;
}) {
  const dispatch = useAppDispatch();
  const { data, isLoading } = useAppSelector(
    (state) => state.expedition.workingPointClients,
  );

  useEffect(() => {
    dispatch(getClientsByPctLucru({ id_punctlucru: workingPointId }));
    return () => {
      dispatch(clearWorkingPointClients());
    };
  }, [dispatch, workingPointId]);

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="flex justify-center py-4">
          <div
            className="h-8 w-8 animate-spin rounded-full border-4 border-[#2196f3]/20 border-t-[#2196f3]"
            role="status">
            <span className="sr-only">Se incarca...</span>
          </div>
        </div>
      );
    }

    if (!data || data.length === 0) {
      return (
        <div className="py-4 text-center text-muted">
          Nici un client adaugat
        </div>
      );
    }

    return (
      <ul className="m-0 list-none space-y-2 p-0">
        {data.map((client) => (
          <li
            key={client.id_client}
            className="rounded-control bg-surface-subtle p-3 text-gray-900">
            {client.client}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <ModalWrapper
      show
      title={`Clienti pentru ${workingPointName}`}
      handleClose={onClose}
      actionsComponent={<CustomButton onClick={onClose}>Inchide</CustomButton>}>
      {renderContent()}
    </ModalWrapper>
  );
}

export default WorkingPointClientsModal;
